import React from 'react';

function TennisGame({ score, updateScore, onBack }) {
  return (
    <div className="tennis-game" style={{ textAlign: 'center', marginTop: 40 }}>
      <h2>Tennis Game</h2>
      <div style={{
        background: 'linear-gradient(180deg, #388e3c 80%, #fff 100%)',
        border: '4px solid #fff',
        borderRadius: 18,
        width: 400,
        height: 220,
        margin: '40px auto',
        position: 'relative',
        boxShadow: '0 4px 16px rgba(0,0,0,0.08)',
        overflow: 'hidden'
      }}>
        {/* Court Lines */}
        <div style={{position: 'absolute', top: '50%', left: 0, width: '100%', height: 4, background: '#fff', transform: 'translateY(-50%)'}} />
        <div style={{position: 'absolute', left: '50%', top: 0, width: 4, height: '100%', background: '#fff', transform: 'translateX(-50%)'}} />
        {/* Net */}
        <div style={{position: 'absolute', top: '50%', left: '10%', width: '80%', height: 2, background: '#bbb', transform: 'translateY(-50%)', zIndex: 2}} />
        {/* Players & Rackets */}
        <span role="img" aria-label="tennis racket" style={{position: 'absolute', left: 80, top: 60, fontSize: 32}}>🎾</span>
        <span role="img" aria-label="player1" style={{position: 'absolute', left: 60, top: 100, fontSize: 38}}>🧑‍🦱</span>
        <span role="img" aria-label="tennis racket" style={{position: 'absolute', right: 80, bottom: 60, fontSize: 32}}>🎾</span>
        <span role="img" aria-label="player2" style={{position: 'absolute', right: 60, bottom: 100, fontSize: 38}}>🧑‍🦰</span>
      </div>
      <div style={{margin:'20px 0'}}>
        <span style={{fontWeight:'bold'}}>{score.teamA} : </span>
        <button onClick={() => updateScore('tennis', score.scoreA-1 >= 0 ? score.scoreA-1 : 0, score.scoreB)}>-</button>
        <span style={{margin:'0 10px'}}>{score.scoreA}</span>
        <button onClick={() => updateScore('tennis', score.scoreA+1, score.scoreB)}>+</button>
        <span style={{margin:'0 20px'}}>|</span>
        <span style={{fontWeight:'bold'}}>{score.teamB} : </span>
        <button onClick={() => updateScore('tennis', score.scoreA, score.scoreB-1 >= 0 ? score.scoreB-1 : 0)}>-</button>
        <span style={{margin:'0 10px'}}>{score.scoreB}</span>
        <button onClick={() => updateScore('tennis', score.scoreA, score.scoreB+1)}>+</button>
      </div>
      <button onClick={onBack}>Back</button>
    </div>
  );
}

export default TennisGame;
